import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../../app.config';

@Injectable()
export class StaircaseListService {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = config.apiEndpointV2;
  }

  private _endpoint: string;
  getStaircaseList(id: string): Observable<any[]> {
    return this._client.get<any[]>(this._endpoint + '/public/staircase-list/' + id);
  }
}
